import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { NotebookFacade, NotebookSidebarPreference, NotebookType } from '@mode/notebooks/contract';
import { OrgTypes } from '@mode/shared/contract-common';
import * as LegacyNotebookSelectors from './legacy-notebook.selectors';
import * as NotebookActions from './notebook.actions';

@Injectable()
export class NotebookService implements NotebookFacade {
  public notebookToken$: Observable<string>;
  public notebookType$: Observable<string>;
  public accountPreference$: Observable<any>;
  public accountContextPlanCode$: Observable<OrgTypes.PlanCode>;

  constructor(private store: Store) {
    this.notebookToken$ = this.store.select(LegacyNotebookSelectors.notebookToken);
    this.notebookType$ = this.store.select(LegacyNotebookSelectors.selectedNotebookType);
    this.accountPreference$ = this.store.select(LegacyNotebookSelectors.accountPreferenceSelector);
    this.accountContextPlanCode$ = this.store.select(LegacyNotebookSelectors.accountContextPlanCode);
  }

  public updatePreference(preference: NotebookSidebarPreference): void {
    this.store.dispatch(NotebookActions.updatePreference({ params: preference }));
  }

  public updateNotebookType(notebookToken: string, notebookType: NotebookType): void {
    this.store.dispatch(NotebookActions.updateNotebookType({ notebookToken, notebookType }));
  }
  createNotebook(reportToken: string): void {
    return this.store.dispatch(NotebookActions.createNotebook({ reportToken }));
  }
}
